import { apiGet, apiPut } from "@/services/apiService";
import type { ApiResponse } from "@/services/apiService";
import type {
  PolicyNumberDetails,
  PolicyNumberPutPayload,
  GetPolicyResponse,
  CommitPayload
} from "@/models/policy";

export const policyService = {

// services/policyService.ts
getPolicyDetails(policyNum: string) {
  return apiGet<PolicyNumberDetails>("PolicyOperations/getpolicynumberdetails", { policyNum });
},
  updatePolicyNumber(payload: PolicyNumberPutPayload): Promise<ApiResponse<any>> {
    return apiPut<any>("PolicyOperations/updatepolicynumber", payload);
  },
 
getPolicyTxnDetails(policyId: string, policyTxnNum: string) {
  return apiGet<GetPolicyResponse>("PolicyOperations/getpolicystatusdetails", { policyId, policyTxnNum });
},

  commitPolicyStatus(payload: CommitPayload): Promise<ApiResponse<any>> {
    return apiPut<any>("PolicyOperations/updatepolicystatus", payload);
  }
};